import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A277A] pt-16 pb-8">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_8209053d-0b10-4383-98c6-27ad656e5b2c/artifacts/8eb1dchd_image.png" 
              alt="MOS Veteran Logo" 
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Building Purpose Through Skill & Self-Mastery
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold uppercase text-sm mb-4 tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/track-1" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Track 1: Personal Mastery
                </Link>
              </li>
              <li>
                <Link to="/track-2" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Track 2: Mastery Through Trade
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Events
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h3 className="text-white font-bold uppercase text-sm mb-4 tracking-wider">
              Our Programs
            </h3>
            <ul className="space-y-2">
              <li className="text-gray-300 text-sm">MOS Book Box</li>
              <li className="text-gray-300 text-sm">MOS Circle</li>
              <li className="text-gray-300 text-sm">MOS Academy</li>
              <li className="text-gray-300 text-sm">Life Skills Through the Chair</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold uppercase text-sm mb-4 tracking-wider">
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-gray-300 text-sm">
                <Mail size={16} className="text-[#D80000]" />
                <a href="mailto:info@mosveteran.org" className="hover:text-white transition-colors">
                  info@mosveteran.org
                </a>
              </li>
              <li className="flex items-center space-x-2 text-gray-300 text-sm">
                <Phone size={16} className="text-[#D80000]" />
                <a href="tel:+4915114445479" className="hover:text-white transition-colors">
                  +49 1511 4445479
                </a>
              </li>
              <li className="text-gray-300 text-sm">
                Kaiserslautern Military Community<br />
                Germany
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#3F54C8] text-center space-y-3">
          <p className="text-gray-400 text-xs">
            Mastery of Self (M.O.S.) is a tax exempt charitable organization (federal tax ID #85-2610451).<br />
            All contributions are tax-deductible to the extent allowable by law.
          </p>
          <p className="text-gray-300 text-sm">
            © {new Date().getFullYear()} MOS Veteran. All rights reserved. | Veteran-Owned & Operated
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;